import { CalculateForeignParkingPriceFastCheckinDTO,
  CalculateParkingPriceResultDTO,
  CheckinUserForeignParkingFastCheckinNoPaymentDTO,
  CheckinUserForeignParkingFastCheckInResultDTO,
  FastCheckinClient,
  ICheckinUserForeignParkingFastCheckinNoPaymentDTO,
  IStartForeignParkingPaymentProcessFastCheckinDTO,
  ParkingQuotaInfoDTO,
  StartForeignParkingPaymentProcessFastCheckinDTO,
  StartForeignParkingPaymentProcessResponseDTO } from 'src/app/base/models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { AuthService } from 'src/app/base/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class FastCheckinService {
  public lastParkingPriceResult: CalculateParkingPriceResultDTO | null = null;

  constructor(
    private fastCheckinClient: FastCheckinClient,
    private authService: AuthService
  ) { }

  public getForeignParkingQuotaInfo(zoneId: number, selectedSubscriptionId: number, controlPlateNumber: string): Observable<ParkingQuotaInfoDTO> {
    return this.fastCheckinClient.getForeignParkingFastCheckinQuotaInfo(zoneId, selectedSubscriptionId, controlPlateNumber);
  }

  public calculateForeignParkingPrice(zoneId: number, selectedSubscriptionId: number, controlPlateNumber: string, intendedParkingDuration: number): Observable<CalculateParkingPriceResultDTO> {
    const dto = new CalculateForeignParkingPriceFastCheckinDTO({
      zoneId: zoneId,
      selectedSubscriptionId: selectedSubscriptionId,
      controlPlateNumber: controlPlateNumber,
      intendedParkingDurationMinutes: intendedParkingDuration
    });
    return this.fastCheckinClient.calculateForeignParkingPriceFastCheckin(dto).pipe(
      tap(result => this.lastParkingPriceResult = result)
    );
  }

  public startForeignParkingPaymentProcess(data: IStartForeignParkingPaymentProcessFastCheckinDTO): Observable<StartForeignParkingPaymentProcessResponseDTO> {
    const dto = new StartForeignParkingPaymentProcessFastCheckinDTO(data);
    return this.fastCheckinClient.startForeignParkingPaymentProcessFastCheckin(dto);
  }

  public checkInWithoutPayment(data: ICheckinUserForeignParkingFastCheckinNoPaymentDTO): Observable<CheckinUserForeignParkingFastCheckInResultDTO> {
    const dto = new CheckinUserForeignParkingFastCheckinNoPaymentDTO(data);
    return this.fastCheckinClient.checkinUserForeignParkingFastCheckinNoPayment(dto, this.authService.getAnonymousUserLanguage());
  }
}
